(function () {
  'use strict';

  var EXCLUDED_HANDLES = ['proefpakket-wasstrips'];

  var STYLE = document.createElement('style');
  STYLE.textContent = [
    '.apc-grid{display:flex;flex-wrap:wrap;justify-content:center;gap:20px;margin:35px 0}',
    '@media(min-width:750px){.apc-grid{gap:40px}}',
    '.apc-grid>[class]{width:calc(50% - 10px)}',
    '@media(min-width:750px){.apc-grid>[class]{width:calc(50% - 20px);max-width:300px}}',
    '.apc-card{text-align:center}',
    '.apc-card-img{position:relative;overflow:hidden;border-radius:30px}',
    '.apc-card-img img{width:100%;display:block;border-radius:30px;transition:transform .3s ease}',
    '.apc-card-img:hover img{transform:scale(1.03)}',
    '.article-template__content .apc-card a,.apc-card a{text-decoration:none!important;color:inherit}',
    '.article-template__content .apc-card a:hover .apc-card-title,.apc-card a:hover .apc-card-title{text-decoration:underline!important}',
    '.article-template__content .apc-card h3,.apc-card-title{font-family:Poppins,sans-serif;font-size:16px;font-weight:500;text-align:center;margin:20px 0 4px!important;line-height:1.3}',
    '@media(min-width:750px){.article-template__content .apc-card h3,.apc-card-title{font-size:24px;margin-top:20px!important;margin-bottom:8px!important}}',
    '.article-template__content .apc-card p,.apc-card-washes{font-family:Sora,sans-serif;font-size:14px!important;font-weight:300;color:#1e1e1e;text-align:center;margin:-4px 0 4px!important;padding:0!important;line-height:1.4!important}',
    '@media(min-width:750px){.article-template__content .apc-card p,.apc-card-washes{font-size:18px!important}}',
    '.apc-card-price{font-family:Sora,sans-serif;text-align:center}',
    '.apc-fade-in{animation:apcFadeIn .4s ease both}',
    '@keyframes apcFadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}',
    '.apc-skeleton{width:calc(50% - 10px)}',
    '@media(min-width:750px){.apc-skeleton{width:calc(50% - 20px);max-width:300px}}',
    '.apc-skeleton-img{aspect-ratio:1/1;border-radius:30px;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%);background-size:200% 100%;animation:apcShimmer 1.5s infinite}',
    '.apc-skeleton-body{padding:16px 0}',
    '.apc-skeleton-line{height:14px;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%);background-size:200% 100%;animation:apcShimmer 1.5s infinite;border-radius:4px;margin:8px auto}',
    '.apc-skeleton-line.w60{width:60%}',
    '.apc-skeleton-line.w40{width:40%}',
    '.apc-skeleton-line.w30{width:30%}',
    '@keyframes apcShimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}'
  ].join('\n');
  document.head.appendChild(STYLE);

  function formatMoney(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20AC' + euros;
  }

  function createSkeleton() {
    var el = document.createElement('div');
    el.className = 'apc-skeleton';
    el.innerHTML =
      '<div class="apc-skeleton-img"></div>' +
      '<div class="apc-skeleton-body">' +
      '<div class="apc-skeleton-line w60"></div>' +
      '<div class="apc-skeleton-line w40"></div>' +
      '<div class="apc-skeleton-line w30"></div>' +
      '</div>';
    return el;
  }

  function getWashCount(source) {
    // source can be a product or variant object
    if (source.title) {
      var m = source.title.match(/(\d+)\s*wasb/i);
      if (m) return m[1];
      // Also check for "wasjes"
      m = source.title.match(/(\d+)\s*wasj/i);
      if (m) return m[1];
    }
    if (source.variants && source.variants.length) {
      for (var i = 0; i < source.variants.length; i++) {
        var v = source.variants[i];
        if (v.title) {
          var vm = v.title.match(/(\d+)\s*wasb/i);
          if (vm) return vm[1];
          vm = v.title.match(/(\d+)\s*wasj/i);
          if (vm) return vm[1];
        }
      }
    }
    if (source.tags) {
      var tags = typeof source.tags === 'string' ? source.tags.split(',') : source.tags;
      for (var j = 0; j < tags.length; j++) {
        var tm = tags[j].trim().match(/(\d+)\s*wasb/i);
        if (tm) return tm[1];
      }
    }
    return null;
  }

  function buildPriceHTML(price, comparePrice) {
    var onSale = comparePrice && comparePrice > price;

    var html = '';
    if (onSale) {
      html += '<div class="flex items-center justify-center gap-2">';
      html += '<s class="text-lg font-thin text-[#969696]">' + formatMoney(comparePrice) + '</s>';
      html += '<span class="text-lg lg:text-2xl font-regular">' + formatMoney(price) + '</span>';
      html += '</div>';
    } else {
      html += '<span class="text-lg lg:text-2xl font-regular">' + formatMoney(price) + '</span>';
    }
    return html;
  }

  function renderCard(data) {
    // data: { url, img, title, price, comparePrice, washCount }
    var card = document.createElement('div');
    card.className = 'apc-card apc-fade-in';

    var washHtml = data.washCount
      ? '<p class="apc-card-washes font-light text-center -mt-1 mb-1 text-sm md:text-lg">' + data.washCount + ' wasbeurten</p>'
      : '';

    card.innerHTML =
      '<div class="apc-card-img product-card relative overflow-hidden group">' +
        '<a href="' + data.url + '" title="' + data.title + '">' +
          '<img src="' + data.img + '" alt="' + data.title + '" loading="lazy" width="466" height="466" class="w-full rounded">' +
        '</a>' +
      '</div>' +
      '<a href="' + data.url + '" title="' + data.title + '">' +
        '<h3 class="apc-card-title lg:text-2xl font-medium text-center mt-5 mb-1 lg:mb-2">' + data.title + '</h3>' +
      '</a>' +
      washHtml +
      '<div class="apc-card-price">' + buildPriceHTML(data.price, data.comparePrice) + '</div>';

    return card;
  }

  function productToCardData(product) {
    return {
      url: '/products/' + product.handle,
      img: product.featured_image || (product.images && product.images[0]) || '',
      title: product.title || '',
      price: product.price,
      comparePrice: product.compare_at_price,
      washCount: getWashCount(product)
    };
  }

  function variantToCardData(product, variant) {
    // Build a display title from the variant (e.g. "Ecofino Wasstrips - Oceaanbries")
    var variantLabel = variant.title.split('/')[0].trim();
    var title = product.title + ' - ' + variantLabel;

    return {
      url: '/products/' + product.handle + '?variant=' + variant.id,
      img: (variant.featured_image && variant.featured_image.src) || product.featured_image || (product.images && product.images[0]) || '',
      title: title,
      price: variant.price,
      comparePrice: variant.compare_at_price,
      washCount: getWashCount(variant)
    };
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found: ' + handle);
        return res.json();
      });
  }

  function init() {
    var contentEl = document.querySelector('.article-template__content');
    if (!contentEl) return;

    var placeholders = contentEl.querySelectorAll('[data-products],[data-variants]');
    if (!placeholders.length) return;

    placeholders.forEach(function (placeholder) {
      var productsAttr = placeholder.getAttribute('data-products');
      var variantsAttr = placeholder.getAttribute('data-variants');

      var handleList = productsAttr
        ? productsAttr.split(',').map(function (h) { return h.trim(); }).filter(Boolean)
        : [];
      var variantIds = variantsAttr
        ? variantsAttr.split(',').map(function (v) { return v.trim(); }).filter(Boolean)
        : [];

      handleList = handleList.filter(function (h) {
        return EXCLUDED_HANDLES.indexOf(h) === -1;
      });
      variantIds = variantIds.filter(function (entry) {
        var parts = entry.split(':');
        var handle = parts.length === 2 ? parts[0].trim() : null;
        return !handle || EXCLUDED_HANDLES.indexOf(handle) === -1;
      });

      var totalCards = handleList.length + variantIds.length;
      if (!totalCards) return;

      var grid = document.createElement('div');
      grid.className = 'apc-grid';

      var skeletons = [];
      for (var s = 0; s < totalCards; s++) {
        var sk = createSkeleton();
        skeletons.push(sk);
        grid.appendChild(sk);
      }

      placeholder.replaceWith(grid);

      // Fetch products (whole product cards)
      var productPromises = handleList.map(function (handle, idx) {
        return fetchProduct(handle)
          .then(function (product) {
            var card = renderCard(productToCardData(product));
            skeletons[idx].replaceWith(card);
          })
          .catch(function (err) {
            console.warn('[article-product-cards]', err.message);
            skeletons[idx].remove();
          });
      });

      // Fetch variants — we need to find which product each variant belongs to
      // Group variant IDs by discovering their parent product
      var variantPromises = [];
      if (variantIds.length) {
        // We need to find the parent product for each variant.
        // If data-products is also set, check those products first.
        // Otherwise, use the Shopify search endpoint.
        var variantOffset = handleList.length;

        // Collect unique handles from data-products to check first
        var productCache = {};

        variantPromises = variantIds.map(function (variantId, vIdx) {
          var skeletonIdx = variantOffset + vIdx;

          // Try to find variant in already-fetched products from data-products
          // We'll use a simple approach: fetch all products from data-products,
          // then for remaining variants, try the variant endpoint
          return new Promise(function (resolve) {
            // First check if any product handle is provided alongside variants
            var allHandles = handleList.slice();
            // Also check data-variant-products attribute for parent product handles
            var variantProductsAttr = placeholder.getAttribute('data-variant-products');
            // Note: placeholder is already replaced, so we read it beforehand
            // Instead, we use a search approach

            // Simple approach: fetch /variants/{id}.json won't work on storefront
            // So we search through products already fetched or use a provided handle

            resolve(null);
          });
        });

        // Better approach: require a data-variant-source="handle" attribute
        // or fetch products from data-products and search variants within them
        // Simplest: for each variant, we need the parent product handle.
        // Let's support: data-variants="handle:variantId,handle:variantId"

        // Actually, simplest robust approach: fetch ALL products from handles,
        // then find variants in them. If variant not found, try fetching
        // all collections products (too complex).

        // BEST approach: support "handle:variantId" format in data-variants
        variantPromises = variantIds.map(function (entry, vIdx) {
          var skeletonIdx = variantOffset + vIdx;
          var parts = entry.split(':');
          var handle, vid;

          if (parts.length === 2) {
            handle = parts[0].trim();
            vid = parts[1].trim();
          } else {
            // Just a variant ID — need to search in already specified products
            vid = parts[0].trim();
            handle = handleList.length ? handleList[0] : null;
          }

          if (!handle) {
            skeletons[skeletonIdx].remove();
            return Promise.resolve();
          }

          var cacheKey = handle;
          var productPromise = productCache[cacheKey]
            ? Promise.resolve(productCache[cacheKey])
            : fetchProduct(handle).then(function (p) { productCache[cacheKey] = p; return p; });

          return productPromise
            .then(function (product) {
              var variant = null;
              for (var i = 0; i < product.variants.length; i++) {
                if (String(product.variants[i].id) === String(vid)) {
                  variant = product.variants[i];
                  break;
                }
              }
              if (!variant) throw new Error('Variant ' + vid + ' not found in ' + handle);
              var card = renderCard(variantToCardData(product, variant));
              skeletons[skeletonIdx].replaceWith(card);
            })
            .catch(function (err) {
              console.warn('[article-product-cards]', err.message);
              skeletons[skeletonIdx].remove();
            });
        });
      }

      Promise.all(productPromises.concat(variantPromises)).then(function () {
        var remaining = grid.querySelectorAll('.apc-card');
        if (!remaining.length) grid.remove();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
